// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"803":"bdde47d8","901":"bdde47d8"}[chunkId] + ".chunk.css";
};